module.exports = __webpack_public_path__ + "static/media/india-address-popup.5b627a4c.png";